import useEditorProps from '@hooks/useEditorProps';
import useSelectedElement from '@hooks/useSelectedElement';
import { ArrowDropDownRounded, ArrowDropUpRounded } from '@mui/icons-material';
import { Box, ButtonBase, Chip, Collapse, Stack } from '@mui/material';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Editor, Transforms } from 'slate';
import { useSlate } from 'slate-react';

function MergeTags() {
    const { t } = useTranslation();
    const { mergeTags, mergeTagsLabels } = useEditorProps();
    const [open, setOpen] = useState(false);
    const { getSelectedElement } = useSelectedElement();
    const editor = useSlate();
    const [selectedElementNode, selectedElementPath] =
        getSelectedElement() || [];

    if (!['rich-text', 'button'].includes(selectedElementNode?.type))
        return null;

    const insertMergeTag = mergeTag => {
        const marks = Editor.marks(editor);
        const mergeTagNode = {
            type: 'merge-tag',
            tag: mergeTag,
            children: [{ text: '', ...marks }],
        };
        Editor.insertNode(editor, mergeTagNode, { select: true });
        Transforms.move(editor, { unit: 'character' });
    };

    return (
        <Box
            sx={{
                position: 'fixed',
                top: 148,
                right: 0,
                maxHeight: 'calc(100vh - 160px)',
                display: 'flex',
                flexDirection: 'column',
                gap: 2,
            }}
        >
            <Box
                sx={{
                    position: 'sticky',
                    top: 0,
                    right: 0,
                    // backgroundColor: 'rgba(0, 0, 0, 0.08)',
                    alignSelf: 'flex-end',
                }}
            >
                <Chip
                    label={t('Merge Tags')}
                    size={open ? 'small' : 'medium'}
                    component={ButtonBase}
                    icon={
                        open ? <ArrowDropUpRounded /> : <ArrowDropDownRounded />
                    }
                    sx={{
                        border: 1,
                        borderColor: 'divider',
                        marginX: 2,
                        cursor: 'pointer',
                    }}
                    onMouseDown={e => {
                        e.preventDefault();
                        e.stopPropagation();
                        setOpen(!open);
                    }}
                    // onClick={() => setOpen(!open)}
                />
            </Box>
            <Collapse in={open}>
                <Stack
                    sx={{
                        alignItems: 'flex-end',
                        overflowY: 'auto',
                        scrollbarWidth: 'none',
                        marginRight: 2,
                        flex: 1,
                        // pointerEvents: 'none',
                    }}
                >
                    {Object.keys(mergeTags).map(key => (
                        <Chip
                            key={key}
                            label={mergeTagsLabels?.[key] || key}
                            size="small"
                            // variant="outlined"
                            component={ButtonBase}
                            sx={{
                                margin: 0.5,
                                // borderRadius: 1,
                                border: 1,
                                borderColor: 'divider',
                                // boxShadow: 1,
                                pointerEvents: 'auto',
                                cursor: 'pointer',
                            }}
                            onMouseDown={e => {
                                e.preventDefault();
                                e.stopPropagation();
                                insertMergeTag(key);
                            }}
                        />
                    ))}
                </Stack>
            </Collapse>
        </Box>
    );
}

export default MergeTags;
